import { render } from "./ConferencePage.vue?vue&type=template&id=c81a70c0"
import script from "./ConferencePage.vue?vue&type=script&lang=js"
export * from "./ConferencePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__